var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M22.2,19.6C22.1,19.7,22,19.9,22,20v1.5c0,0.3,0.2,0.5,0.5,0.5c0.1,0,0.3,0,0.3-0.1l7-6.5 c0.2-0.2,0.2-0.5,0-0.7c0,0,0,0,0,0l-7-6.5c-0.2-0.2-0.5-0.2-0.7,0C22,8.3,22,8.4,22,8.5V10c0,0.1,0.1,0.3,0.2,0.4l4,3.6H8.5 C8.2,14,8,14.2,8,14.5v1C8,15.8,8.2,16,8.5,16h17.7L22.2,19.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2,30h16c1.1,0,2-0.9,2-2v-4.5c0-0.3-0.2-0.5-0.5-0.5h-1c-0.3,0-0.5,0.2-0.5,0.5V28H2V2h16v4.5 C18,6.8,18.2,7,18.5,7h1C19.8,7,20,6.8,20,6.5V2c0-1.1-0.9-2-2-2H2C0.9,0,0,0.9,0,2v26C0,29.1,0.9,30,2,30z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogout);
export default __webpack_public_path__ + "static/media/icon-logout.96f1049c650d6b59cc5e956b2dd147b7.svg";
export { ForwardRef as ReactComponent };